import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReportPage } from '../models/powerbi';
import { RootState } from '../redux/store';

// Define a type for the slice state
interface PowerBIState {
	value: any;
}

// Define the initial state using that type
const initialState: PowerBIState = {
	value: null,
};

export const powerBISlice = createSlice({
	name: 'powerbi',
	initialState,
	reducers: {
		setPowerBIResponse: (state, action: PayloadAction<any>) => {
			state.value = action.payload;
		},
	},
});

export const { setPowerBIResponse } = powerBISlice.actions;

export const selectPowerBIDefaultPageId = (state: RootState): string | null => {
	const pages = state.powerbi.value?.pages as ReportPage[] | undefined;
	if (!pages?.length) {
		return null;
	}
	const activePage = pages.find((page) => page.isActive);
	if (activePage) {
		return activePage.id;
	}
	const sorted = [...pages].sort((a, b) => a.order - b.order);
	return sorted[0]?.id ?? null;
};

export default powerBISlice.reducer;
